import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: pp81381
 * id BE2FFED1-BB12-4CBD-A809-7E5BEA984E2F
 * name projector-screen-variant-off
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/projector-screen-variant-off.svg
 * tags
 * - Home Automation 
 */
export const ProjectorScreenVariantOffIcon = createSvgIcon(<><path d="M20.84 22.73L16.11 18H5V9H4C3.45 9 3 8.55 3 8V7C3 6.45 3.45 6 4 6H4.11L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M19 9H20C20.55 9 21 8.55 21 8V7C21 6.45 20.55 6 20 6H9.2L19 15.8V9Z" /></>, 'ProjectorScreenVariantOffIcon');
export default ProjectorScreenVariantOffIcon